import { Input } from "../FormElements";
import { ReplaceWithDataSource } from "../helpers/variable";

export const GraphicEditor = ({ cue, onUpdate }) => {
	return (
		<>
			<Input
				label="Line one"
				value={cue.line_one}
				onChange={(value) => {
					onUpdate({
						line_one: value,
					});
				}}
			/>
			<Input
				label="Line two"
				value={cue.line_two}
				onChange={(value) => {
					onUpdate({
						line_two: value,
					});
				}}
			/>
		</>
	);
};

export const GraphicCueContent = ({
	cue,
	dynamicText,
	dynamicLists,
	twoLines,
}) => {
	return (
		<div
			className={`overflow-ellipsis w-48 md:w-auto max-w-xs md:max-w-sm lg:max-w-lg overflow-hidden
        ${twoLines ? "whitespace-normal max-h-10" : "whitespace-nowrap"}
        `}
		>
			<span className="font-semibold">
				{<ReplaceWithDataSource text={cue.body} keepBrakets={true} styled={true} /> ||
					"Message"}
			</span>
		</div>
	);
};
